module.exports = __webpack_public_path__ + "static/apply-modal-4f4c0356b6b25ca1137845b809f6537d.svg";